export class Config {
  private _apiBase!: string
  private _headerHost!: string
  private _saveKv!: (key: string, value: string) => Promise<void>
  private _loadKv!: (key: string) => Promise<string>

  private _refreshIntervalMs?: number

  constructor() {
    const viteEnv = import.meta.env
    const nodeEnv = typeof process !== 'undefined' ? process.env : undefined

    this._apiBase = viteEnv.VITE_API_BASE ?? nodeEnv?.VITE_API_BASE ?? ''
    this._headerHost = viteEnv.VITE_HEADER_HOST ?? nodeEnv?.VITE_HEADER_HOST ?? ''

    this._saveKv = async (key: string, value: string) => {
      localStorage.setItem(key, value)
    }
    this._loadKv = async (key: string) => {
      return localStorage.getItem(key) ?? JSON.stringify(null)
    }
  }

  getApiBase(): string {
    if (!this._apiBase) {
      throw new Error('apiBase is not set')
    }
    return this._apiBase
  }

  setApiBase(value: string): void {
    this._apiBase = value
  }

  getHeaderHost(): string {
    if (!this._headerHost) {
      throw new Error('headerHost is not set')
    }
    return this._headerHost
  }

  setHeaderHost(value: string): void {
    this._headerHost = value
  }

  getRefreshIntervalMs(): number {
    return this._refreshIntervalMs ?? 5 * 60 * 1000
  }

  setRefreshIntervalMs(value: number): void {
    this._refreshIntervalMs = value
  }

  getSaveKv(): (key: string, value: string) => Promise<void> {
    if (!this._saveKv) {
      throw new Error('saveKv is not set')
    }
    return this._saveKv
  }

  getLoadKv(): (key: string) => Promise<string> {
    if (!this._loadKv) {
      throw new Error('loadKv is not set')
    }
    return this._loadKv
  }

  setSaveKv(value: (key: string, value: string) => Promise<void>): void {
    this._saveKv = value
  }

  setLoadKv(value: (key: string) => Promise<string>): void {
    this._loadKv = value
  }
}

export const config = new Config()
